import React from 'react';
import type { RelanceAgendaEntry } from '../../types/customerFollowUp/relanceAgenda';
import { RelanceRankTag } from './RelanceRankTag';

interface RelanceAgendaTagProps {
    entry: RelanceAgendaEntry;
    testId?: string;
}

// relanceCount counts the sends before this relance, sent or not.
export const RelanceAgendaTag: React.FC<RelanceAgendaTagProps> = ({ entry, testId }) => (
    <RelanceRankTag rank={entry.item.relanceCount + 1} sent={entry.status === 'sent'} variant="spelled" testId={testId} />
);
